<!-- Don't touch elemnts that have id, cause they are used in unit test -->
<div class="container">
  <div>
    <ui-tabset id="tabset-1" uiSize="large" [(uiSelectedIndex)]="selectedIndex" uiType="editable-card" (uiAdd)="newTab()" (uiClose)="closeTab($event)">
      <ui-tab *ngFor="let tab of tabs" uiClosable [uiTitle]="tab">This is the content of: {{ tab }}</ui-tab>
    </ui-tabset>
  </div>
  <ui-divider></ui-divider>
  <!-- This should be second example, otherwise will breake unit tests ;( -->
  <div>
    <div class="mb-16px mt-20px">
      <strong>Tab position:</strong>
      <ui-select [(ngModel)]="position" style="width: 80px">
        <ui-option *ngFor="let option of options" [uiLabel]="option.label" [uiValue]="option.value"></ui-option>
      </ui-select>
    </div>
    <ui-tabset id="tabset-2" [uiTabPosition]="position" style="height: 150px">
      <ui-tab *ngFor="let tab of tabsWithPossition" [uiTitle]="'Tab ' + tab">Content of tab {{ tab }}</ui-tab>
      <ui-tab uiTitle="Tab 4">Content of Tab 4</ui-tab>
      <ui-tab uiDisabled uiTitle="Tab 5">Content of Tab 5</ui-tab>
    </ui-tabset>
  </div>
  <ui-divider></ui-divider>
  <div>
    <ui-tabset uiCentered>
      <ui-tab *ngFor="let tab of tabsWithIcons" [uiTitle]="titleTemplate">
        <ng-template #titleTemplate>
          <ui-icon [uiType]="tab.icon"></ui-icon>
          {{ tab.name }}
        </ng-template>
        This is the icon of {{ tab.name }}: <ui-icon [uiType]="tab.icon"></ui-icon>
      </ui-tab>
    </ui-tabset>
  </div>
</div>
